/**
 * Text Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import { textElementSchema, type TextElementData } from './schema';
import { TextEdit } from './TextEdit';
import { TextPlayer } from './TextPlayer';

export { textElementSchema, type TextElementData };
export { TextEdit };
export { TextPlayer };

export const textElement: ElementDefinition<TextElementData, void> = {
    schema: textElementSchema,
    EditComponent: TextEdit as any,
    PlayerComponent: TextPlayer as any,
};
